namespace $.$$ {
	export class $shm_showcase_preview extends $.$shm_showcase_preview {
		file_title() { return this.files()[0]?.name ?? 'Файл' }
		@ $mol_mem
		chart_option() {
			return {
				animation: false,
				grid: { left: 0, right: 0, top: 4, bottom: 4 },
				xAxis: { type: 'category', show: false, data: [ 'Пн', 'Вт', 'Ср', 'Чт', 'Пт' ] },
				yAxis: { type: 'value', show: false },
				series: [ { type: 'bar', data: [ 3, 7, 5, 9, 6 ] } ],
			}
		}
		content() {
			switch( this.entry_id() ) {
				case 'shm_paginator': return [ this.Shm_paginator() ]
				case 'chart': return [ this.Chart() ]
				case 'calendar': return [ this.Calendar_pick() ]
				case 'stack': return [ this.Stack() ]
				case 'pop': return [ this.Pop() ]
				case 'lights_toggle': return [ this.Lights() ]
				case 'theme_auto': return [ this.Theme() ]
				case 'button_share': return [ this.Share() ]
				case 'shm_file_drop': return [ this.File_drop() ]
				case 'shm_period': return [ this.Period_pick() ]
				case 'form': return [ this.Form_pick() ]
				case 'grid': return [ this.Grid() ]
				case 'search': return [ this.Search() ]
				case 'textarea': return [ this.Textarea() ]
				case 'check_list': return [ this.Checks() ]
				case 'shm_check_list': return [ this.Shm_checks() ]
				case 'select_list': return [ this.Multiple() ]
				case 'section': return [ this.Section() ]
				case 'toolbar': return [ this.Toolbar() ]
				case 'deck': return [ this.Deck() ]
				case 'gallery': return [ this.Gallery() ]
				case 'scroll': return [ this.Scroll() ]
				case 'frame': return [ this.Frame() ]
				case 'shm_echarts': return [ this.Echarts() ]
				case 'text': return [ this.Text() ]
				case 'text_code': return [ this.Code() ]
				case 'number': return [ this.Number() ]
				case 'switch': return [ this.Switch() ]
				case 'select': return [ this.Select() ]
				case 'date': return [ this.Date() ]
				case 'pick_time': return [ this.Time() ]
				case 'format': return [ this.Format() ]
				case 'paginator': return [ this.Paginator() ]
				case 'link': return [ this.Link() ]
				case 'pick': return [ this.Pick() ]
				case 'pop_over': return [ this.Hover() ]
				case 'expander': return [ this.Expander() ]
				case 'labeler': return [ this.Labeler() ]
				case 'card': return [ this.Card() ]
				case 'list': return [ this.List() ]
				case 'bar': return [ this.Bar() ]
				case 'speck': return [ this.Speck() ]
				case 'avatar': return [ this.Avatar() ]
				case 'portion': return [ this.Portion() ]
				case 'check_box': return [ this.Check() ]
				case 'string': return [ this.String() ]
				case 'button': return [ this.Button() ]
				case 'shm_dotsloader': return [ this.Loader() ]
				default: return [ '—' ]
			}
		}
	}
}
